module.exports = "/_next/static/resources/ingredients-0dbf2ec7f39af00ca490903c3b60d78d.jpg";